import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=82cb2142&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=82cb2142&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cb2142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82cb2142')) {
      api.createRecord('82cb2142', component.options)
    } else {
      api.reload('82cb2142', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=82cb2142&scoped=true", function () {
      api.rerender('82cb2142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/UserList.vue"
export default component.exports